import Button from "components/button/Button";
import FormInput from "components/formInput/Input";
import { useFormik } from "formik";
import useNotify from "hooks/useNotify";
import { isEmpty } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import React from 'react';
import { Container, Row, Col } from 'react-grid';

import * as Yup from "yup";
import "./styles.scss";
import Lable from "components/label/label";
import DatePickerComponent from "components/datepicker/Datepicker";
import Select from "components/select/Select";
import Cookies from "js-cookie";
import FacilityApiHook from "hooks/facility/facilityApiHook";
import FacilityHook from "hooks/facility/facilityHook";
import GroupApiHook from "hooks/group/groupApiHook";
import GroupHook from "hooks/group/groupHook";
import PartnerApiHook from "hooks/partner/partnerApiHook";
import PartnerHook from "hooks/partner/partnerHook";
import { Input } from "antd";
import HomeHook from "hooks/home/homeHook";
import HomeApiHook from "hooks/home/homeApiHook";
import CSVApiHook from "hooks/csv/csvApiHook";
import CSVHook from "hooks/csv/csvHook";
import moment from "moment/moment";
import { resetMessages } from "store/csv/actions";
import { getPatientByFacilities } from "store/patients/actions";


const CsvExportSanwa = () => {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const { showToastSuccess, showToastError } = useNotify();

    const { exportListFacilities, exportListPatients, exportDataSensor } = CSVApiHook();

    const [isAuthen, setIsAuthen] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const [dataTypeOptions, setDataTypeOptions] = useState([]);

    const [selectedGroup, setSelectedGroup] = useState({});
    const { getListFacility } = FacilityApiHook();
    const { getListGroup2 } = GroupApiHook();
    const { getListPartner } = PartnerApiHook();

    const [disableExport, setDEX] = useState(false);
    const [invalidRangeDate, setIRD] = useState(true);

    const { facilityList } = FacilityHook();
    const { groupList2 } = GroupHook();
    const { partnerList } = PartnerHook();
    const { callGetPatientByFacility } = HomeApiHook();
    const { patientList } = HomeHook();

    const { exportedLink, inProgressExport, success, error, } = CSVHook();

    // Dùng trực tiếp flag loading của store (không qua hook) để phân biệt "đang tải list"
    // với "list thật sự rỗng" — nếu không, message sẽ nhấp nháy trong lúc request chưa về.
    const { loadingFacilities } = useSelector((state) => state.FacilityReducer);
    const { loadingPatients } = useSelector((state) => state.PatientReducer);

    // Store khởi tạo facilities/patients = [] nên "rỗng" và "chưa gọi API" không phân biệt được.
    // 2 flag dưới bật lên khi đã có ít nhất 1 request đi ra → chỉ kết luận "không có data" sau đó.
    const [facilitiesFetched, setFacilitiesFetched] = useState(false);
    const [patientsFetched, setPatientsFetched] = useState(false);

    useEffect(() => {
        if (loadingFacilities) {
            setFacilitiesFetched(true);
        }
    }, [loadingFacilities]);

    useEffect(() => {
        if (loadingPatients) {
            setPatientsFetched(true);
        }
    }, [loadingPatients]);

    const [externalLink, setEL] = useState('');

    useEffect(() => {
        setEL(exportedLink);
    }, [exportedLink]);

    const formik = useFormik({
        validateOnChange: false,
        initialValues: {
            startDate: null,
            endDate: null,
            partnerId: 'DEFAULT_SANWA',
            groupId: undefined,
            facilityId: undefined,
            dataType: undefined,
            patientExprotId: undefined,
            patientName: '',
            patientCode: '',
            facilityName: '',
        },
        validationSchema: Yup.object({
        }),
        onSubmit: (values, { setErrors, resetForm }) => {
            if (dataType == '0') {
                if (values && values.partnerId && values.partnerId != 'DEFAULT_SANWA') {
                    exportListFacilities({ ...values });
                } else {
                    exportListFacilities();
                }
            }

            if (dataType == '1') {

                const submitPartnerId = partnerId == "DEFAULT_SANWA" ? "SANWA" : partnerId;
                console.log(submitPartnerId);

                exportListPatients({ ...values, ...{ partnerId: submitPartnerId }, ...(facilityId !== 'INDIVIDUAL') ? {} : { groupId: groupId == undefined ? 'ALL' : groupId }, ...(isAdminFacility(userInfo) ? { facilityId: userInfo.id, facilityName: userInfo.name } : {}) });
            }

            if (dataType == '2') {
                if (isAdminFacility(userInfo) && (!groupId && !patientExprotId)) {
                    showToastError(t('msg.export_invalid_data'));
                    return
                }

                if (isAdminSanwa(userInfo) && (partnerId == '' && facilityId == '' && groupId == '' && patientExprotId == '')) {
                    showToastError(t('msg.export_invalid_data'));
                    return
                }

                if (isPartner(userInfo) && (facilityId == '' && groupId == '' && patientExprotId == '')) {
                    showToastError(t('msg.export_invalid_data'));
                    return
                }

                const submitPartnerId = partnerId == "DEFAULT_SANWA" ? "SANWA" : partnerId;
                console.log(submitPartnerId);

                exportDataSensor({ ...values, ...{ partnerId: submitPartnerId }, ...(isAdminFacility(userInfo) ? { facilityName: userInfo.name, facilityId: facilityId, group_id: groupId, partner_id: submitPartnerId } : {}) });
            }
        },
        onChange: () => {

        }
    });

    const {
        startDate,
        endDate,
        groupId,
        staffId,
        facilityId,
        dataType,
        partnerId,
        patientExprotId,
    } = formik.values;

    useEffect(() => {
        setEL('')
        // Spec: đổi データ種別 → reset field con về default (利用者 = 全ての患者).
        formik.setFieldValue('patientExprotId', 'ALL')

        // Spec (edge #1/#3/#4): list con rỗng vẫn cho export với ALL → KHÔNG khoá button theo list rỗng.
        // Button chỉ disabled khi chưa chọn データ種別 hoặc (SENSOR_DATA) date chưa hợp lệ — xử lý ở prop `disabled`.
        if (dataType == '0') {
            // 事業者リスト: chỉ chờ partner list load xong (adminSanwa). 提携先無し (DEFAULT_SANWA) vẫn hợp lệ.
            setDEX(isAdminSanwa(userInfo) && partnerList == undefined);
            return;
        }
        setDEX(false);
    }, [dataType]);


    useEffect(() => {
        const userInfoString = Cookies.get("USER_INFO");
        setIsAuthen(!!userInfoString);
        if (userInfoString) {
            const userInfomation = JSON.parse(userInfoString)
            setUserInfo(userInfomation);

            console.log("userInfo");
            console.log(userInfomation);
            const options = [
                ...!isAdminFacility(userInfomation) ? [{ label: t('export_page.options.facility'), value: '0' }] : [],
                ...[
                    { label: t('export_page.options.group_n_user'), value: '1' }, // {/* danh sach benh nhan */}
                    { label: t('export_page.options.data_sensor'), value: '2' }, // data benh nhan (semsor)
                ],
            ];
            setDataTypeOptions(options)
            // Spec: onload データ種別 = null (không auto-select), chưa hiển thị filter nào.

            if (dataTypeOptions.length == 0) {
                if (isAdminSanwa(userInfomation)) {
                    getListPartner();
                }
            }

            if (isAdminFacility(userInfomation)) {
                formik.setFieldValue('facilityId', userInfomation.id);
                getListGroup2({ facility_id: userInfomation.id, partner_id: partnerId });

            }


            if (isPartner(userInfomation)) {
                formik.setFieldValue('partnerId', userInfomation.id);
            }

        }
    }, []);

    useEffect(() => {
        setEL('')

        // 事業者連携なし: 利用者 không thuộc group nào → effect riêng bên dưới load list.
        // Thoát sớm (trước cả khi reset 利用者) để không ghi đè bằng kết quả rỗng.
        if (facilityId === 'INDIVIDUAL') {
            return
        }

        formik.setFieldValue('patientExprotId', undefined)

        if (groupId == undefined || groupId == '') {
            return
        }

        const partnerIdSubmit = partnerId == 'DEFAULT_SANWA' ? "ALL" : partnerId;


        console.log('useEffect patient filter', partnerId, facilityId, groupId)

        if (facilityId != undefined || isAdminFacility(userInfo)) {
            dispatch(getPatientByFacilities({ facility_id: facilityId != '' && facilityId != undefined ? facilityId : userInfo.id, group_id: groupId, partner_id: partnerIdSubmit, patient_id: facilityId === "ALL_PERSONAL" ? "ALL" : undefined }));
        }
        // Deps phải gồm cả 事業者/提携先: グループ mặc định luôn là 'ALL' nên khi đổi 事業者
        // giá trị groupId không đổi ('ALL' → 'ALL'), effect chỉ nghe [groupId] sẽ không chạy lại
        // và 利用者 vẫn giữ list của 事業者 trước đó (không khớp filter).
        // Saga dùng takeLatest nên nếu có 2 lần dispatch liên tiếp (groupId reset sau khi group list về)
        // thì chỉ kết quả của request cuối được ghi vào store.
    }, [groupId, facilityId, partnerId]);

    useEffect(() => {
        setEL('')
        formik.setFieldValue('patientExprotId', undefined);

        if (partnerId == undefined) {
            return
        }


        if (isAdminSanwa(userInfo) || isPartner(userInfo)) {
            getListFacility({ partner_id: partnerId });
        }
    }, [partnerId, partnerList]);


    useEffect(() => {
        setEL('')
        if (facilityId == undefined) {
            return
        }

        // formik.setFieldValue('patientExprotId', undefined);
        if (facilityId == 'ALL') {
            formik.setFieldValue('facilityName', t('all_facilities'))
        }

        // 事業者連携なし là option ảo, không có trong facilityList → phải gán tên thủ công.
        // Nếu không, facilityName giữ nguyên tên 事業者 đã chọn trước đó và lọt vào tên file CSV.
        if (facilityId === 'INDIVIDUAL') {
            formik.setFieldValue('facilityName', t('personal'))
        }

        const selectedF = facilityList.find((e) => e.id == facilityId);
        //  check selected Partner
        getListGroup2({ facility_id: facilityId, partner_id: partnerId });

        if (!selectedF) {
            return
        }
        formik.setFieldValue('facilityName', isAdminFacility(userInfo) ? userInfo.name : selectedF.name)
        // partnerId nằm trong deps: đổi 提携先 khi 事業者 vẫn đang là 全ての事業者 ('ALL') sẽ không làm
        // facilityId đổi giá trị → nếu chỉ nghe [facilityId] thì グループ giữ list của 提携先 cũ.
    }, [facilityId, partnerId]);

    useEffect(() => {
        if (dataType == '0' || dataType == undefined) {
            return;
        }

        // Spec: グループ default luôn = 全てのグループ (ALL); đổi 事業者 → reset group về ALL.
        formik.setFieldValue('groupId', 'ALL');
        setDEX(false);
    }, [groupList2, dataType]);

    useEffect(() => {
        // 事業者連携なし: load 利用者 chưa gán 事業者 (facility_id NULL). Không đi qua effect [groupId]
        // vì nhóm 利用者 này không thuộc group nào.
        // 提携先無し phải gửi "SANWA" (không phải "ALL") để BE vào nhánh filterPatientBySanwa —
        // cùng quy ước với lúc export, nếu không list ở dropdown sẽ lệch với nội dung file CSV.
        if (dataType == '0' || dataType == undefined || facilityId !== 'INDIVIDUAL') {
            return;
        }

        const partnerIdSubmit = partnerId == 'DEFAULT_SANWA' ? "SANWA" : partnerId;
        dispatch(getPatientByFacilities({ facility_id: facilityId, group_id: 'ALL', partner_id: partnerIdSubmit, patient_id: undefined }));
    }, [facilityId, partnerId, dataType]);

    useEffect(() => {
        // 利用者 chỉ dùng cho SENSOR_DATA (dataType '2').
        if (dataType != '2') {
            return;
        }

        // Spec: 利用者 default = 全ての患者 (ALL). Kể cả khi group không có 利用者 nào,
        // vẫn giữ option ALL và cho export (edge case #4 → file trả về データなし).
        formik.setFieldValue('patientExprotId', 'ALL');
        additionalFieldsPatient('ALL');
        setDEX(false);
    }, [patientList, dataType]);

    useEffect(() => {
        // 事業者リスト (dataType 0) không phụ thuộc facilityList → không được khoá button theo list rỗng.
        // (được xử lý riêng ở effect [dataType]: DEFAULT_SANWA / 提携先無し vẫn hợp lệ.)
        if (dataType == '0') {
            return;
        }

        if (isAdminSanwa(userInfo) || isPartner(userInfo)) {
            formik.setFieldValue('facilityId', undefined);
        }

        if (facilityList?.length > 0) {
            // Spec: 事業者 default = 全ての事業者 (ALL), không phải facility đầu tiên.
            formik.setFieldValue('facilityId', 'ALL');
            setDEX(false);
        } else {
            setDEX(true);
        }
    }, [facilityList]);

    useEffect(() => {
        console.log('export_csv_successfully or fail', success, error);
        if (success?.type === "GET") {
            showToastSuccess(t("msg.export_csv_successfully"));
            dispatch(resetMessages())
        }
        if (error?.code === 400) {
            showToastError(t("msg.export_csv_failed"));
            dispatch(resetMessages())

        }

    }, [success, error]);

    const additionalFieldsPatient = (v) => {
        if (v == 'ALL') {
            formik.setFieldValue('patientName', 'ALL')
            formik.setFieldValue('patientCode', 'ALL')

            return;
        }


        const selectedPatient = patientList.find((e) => e.id == v);

        if (!selectedPatient) {
            formik.setFieldValue('patientName', '')
            formik.setFieldValue('patientCode', '')
            return;
        }
        formik.setFieldValue('patientName', `${selectedPatient.name} ${selectedPatient.last_name}`)
        formik.setFieldValue('patientCode', selectedPatient.code)
    }

    useEffect(() => {
        setIRD(false)

        if (!startDate && !endDate) {
            return
        }

        if (dataType != '2') {
            return;
        }

        const start = moment(startDate).startOf('day');
        // BE giới hạn tối đa 31 ngày tính cả 2 đầu (getDiffDate có +1) => chênh lệch tối đa 30 ngày
        const maxRange = moment(start).add(30, 'days').format();
        const end = moment(endDate).startOf('day');
        setIRD(false)
        console.log("change date", start.isSameOrAfter(end));

        if (!start.isSameOrBefore(end)) {
            showToastError(t('msg.export_csv_date_time_invalid_before_start'));
            setIRD(true)
            return
        } else
            if (end.isAfter(maxRange)) {
                showToastError(t('msg.export_csv_date_time_invalid_out_of_range'));
                setIRD(true)
                return
            }
    }, [startDate, endDate]);


    // Tổ hợp filter mà chắc chắn không sinh ra dòng nào → khoá button + hiện lý do,
    // thay vì để user export rồi nhận file trống (データなし).
    // Chỉ kết luận khi request tương ứng đã về (loading = false), tránh báo sai lúc đang tải.
    const noDataReason = useMemo(() => {
        // 事業者リスト (dataType 0) luôn có data (提携先無し vẫn hợp lệ) → không check.
        if (!dataType || dataType == '0') {
            return null;
        }

        // 事業者 dropdown rỗng: 提携先 đang chọn không có cơ sở nào.
        // (adminFacility không có dropdown này, facilityList luôn rỗng → phải loại trừ.)
        if ((isAdminSanwa(userInfo) || isPartner(userInfo)) && facilitiesFetched && !loadingFacilities && facilityList.length == 0) {
            return t('msg.export_no_facility');
        }

        const noPatient = patientsFetched && !loadingPatients && (patientList?.length ?? 0) == 0;

        // SENSOR_DATA: không có 利用者 nào khớp 事業者/グループ → không thể có bản ghi sensor.
        if (dataType == '2' && noPatient) {
            return t('msg.export_no_patient');
        }

        // グループ・利用者リスト với 事業者連携なし: nhóm này không thuộc group nào,
        // nên file chỉ gồm 利用者 — không có 利用者 thì file rỗng.
        if (dataType == '1' && facilityId === 'INDIVIDUAL' && noPatient) {
            return t('msg.export_no_patient');
        }

        return null;
    }, [dataType, facilityId, userInfo, facilitiesFetched, loadingFacilities, facilityList, patientsFetched, loadingPatients, patientList, t]);

    return (<div>
        <form className="csv-optional-container" onSubmit={formik.handleSubmit}>
            <Container fluid >
                <Input type="hidden" value={isAdminFacility(userInfo) ? 'ADMIN_FACILITY' : isAdminSanwa(userInfo) ? 'ADMIN_SANWA' : 'PARTNER'}></Input>
                <div style={{ marginBlock: 20 }}>
                    <Row>
                        <Col offset={{ xs: 3 }} md={2}>
                            <Lable label={t('export_page.data_type')}></Lable> {/* Loai du lieu */}
                        </Col>
                        <Col>
                            <div style={{ marginInline: 10 }}>
                                <Select
                                    placeholder={t('please_select')}
                                    name='dataType'
                                    id='dataType'
                                    value={formik.values.dataType || undefined}
                                    onChange={(v) => {
                                        formik.setFieldValue('dataType', v);
                                    }}
                                    options={dataTypeOptions}
                                    width={445}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                {dataType == '2' && <div style={{ marginBlock: 20 }}>
                    <Row>
                    <Col offset={{ xs: 3 }} md={2}>
                        <Lable label={t('export_page.range_date')}></Lable>
                    </Col>
                    <Col md={7}>

                        <div style={{ marginInline: 10 }}>
                            <Row>
                                <DatePickerComponent
                                    placeholder="2024/02/12"
                                    value={startDate}
                                    onChange={(v) => formik.setFieldValue('startDate', Date.parse(v))}
                                />
                                ~
                                <DatePickerComponent
                                    placeholder="2024/03/12"
                                    value={endDate}
                                    onChange={(v) => formik.setFieldValue('endDate', Date.parse(v))}
                                />
                            </Row>
                        </div>
                    </Col>
                    </Row>
                </div>}

                {(isAdminSanwa(userInfo)) ?
                    <div style={{ marginBlock: 20 }}>
                        <Row >
                            <Col offset={{ xs: 3 }} md={2}>
                                <Lable label={t('export_page.partner')}></Lable>
                            </Col>
                            <Col>
                                <div style={{ marginInline: 10 }}>
                                    <Select
                                        placeholder={t('export_page.partner')}
                                        value={partnerId}
                                        options={[{ label: t('no_partner'), value: 'DEFAULT_SANWA' }, ...(partnerList ?? []).map((e) => {
                                            return { label: e.name, value: e.id };
                                        })]}
                                        onChange={(v) => {
                                            console.log("formik.setFieldValue('partnerId', v)", v);
                                            formik.setFieldValue('partnerId', v);
                                        }}
                                        width={445}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div> : <div></div>
                }
                {
                    <div style={{ marginBlock: 20, display: ((isAdminSanwa(userInfo) || isPartner(userInfo)) && (dataType === '1' || dataType === '2')) ? 'block' : 'none' }}>
                        <Row>
                            <Col offset={{ xs: 3 }} md={2}>
                                <Lable label={t('export_page.facility')}></Lable> {/* Ten co so */}
                            </Col>
                            <Col>
                                <div style={{ marginInline: 10 }}>
                                    <Select
                                        placeholder={t('export_page.facility')}
                                        value={facilityId}
                                        options={[...(facilityList.length > 0) ? [{ label: t('all_facilities'), value: 'ALL' }] : [], ...(isPartner(userInfo) || isAdminSanwa(userInfo)) ? [{ label: t('personal'), value: 'INDIVIDUAL' }] : [], ...facilityList.map((e) => { return { label: e.name, value: e.id }; })]}
                                        onChange={(v) => {
                                            formik.setFieldValue('facilityId', v);
                                        }}
                                        width={445}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                }

                {facilityId !== 'INDIVIDUAL' && <div style={{ marginBlock: 20, display: ((dataType == '2' || dataType == '1')) ? 'block' : 'none' }}>
                    <Row>
                        <Col offset={{ xs: 3 }} md={2}>
                            <Lable label={t('export_page.group')}></Lable> {/* Ten group */}
                        </Col>
                        <Col>
                            <div style={{ marginInline: 10 }}>
                                <Select
                                    placeholder={t('all_groups')}
                                    value={groupId}
                                    options={[{ label: t('all_groups'), value: 'ALL' }, ...groupList2.map((e) => { return { label: e.name, value: e.id }; })]}
                                    onChange={(v) => { formik.setFieldValue('groupId', v) }}
                                    width={445}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>}

                {<div style={{ marginBlock: 20, display: (dataType == '2') ? 'block' : 'none' }}>
                    <Row>
                        <Col offset={{ xs: 3 }} md={2}>
                            <Lable label={t('export_page.staff')}></Lable> {/* Benh nhan */}
                        </Col>
                        <Col>
                            <div style={{ marginInline: 10 }}>
                                <Select
                                    placeholder={t('all_patients')}
                                    // Spec: 利用者 luôn có option 全ての患者 (ALL) + list patient của group đang chọn.
                                    value={patientExprotId}
                                    options={[{ label: t('all_patients'), value: 'ALL' }, ...(patientList ?? []).map((e) => { return { label: `${e.name} ${e.last_name}`, value: e.id }; })]}
                                    onChange={(v) => {
                                        formik.setFieldValue('patientExprotId', v)
                                        additionalFieldsPatient(v);
                                        setEL('')
                                    }}
                                    width={445}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>}

                {/* Button + message + link dùng chung grid với các filter phía trên
                    (offset 3 + md 2 cho label, marginInline 10, width 445) để thẳng cột với dropdown. */}
                <div style={{ marginBlock: 20 }}>
                    <Row>
                        <Col offset={{ xs: 3 }} md={2}>
                            <div></div>
                        </Col>
                        <Col>
                            <div style={{ marginInline: 10, width: 445 }}>
                                <Button
                                    key="back"
                                    text={t('export_page.btn')}
                                    className="csv-submit-button"
                                    background="#0E6FBA"
                                    // Spec: button disabled onload (chưa chọn データ種別), khi thiếu required field,
                                    // khi date range của SENSOR_DATA chưa chọn / không hợp lệ,
                                    // hoặc khi filter chắc chắn không có data (noDataReason).
                                    disabled={!dataType || disableExport || invalidRangeDate || !!noDataReason || (dataType === '2' && (!startDate || !endDate))}
                                    loading={inProgressExport}
                                    type="submit"
                                    width={445}
                                />
                                {noDataReason && <div className="csv-no-data-message">{noDataReason}</div>}
                                <div className="csv-exported-link-wrapper">
                                    <a
                                        className="csv-exported-link"
                                        href={externalLink}
                                        target="_blank"
                                    >
                                        {externalLink.split('/')[externalLink.split('/').length - 1]}
                                    </a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </form>
    </div>);
};

const isAdminSanwa = (userInfo) => userInfo.role == "ROLE_FACILITY" && userInfo.is_sys_admin;
const isPartner = (userInfo) => userInfo.role == "ROLE_PARTNER" && !userInfo.is_sys_admin;
const isAdminFacility = (userInfo) => userInfo.role == "ROLE_FACILITY" && !userInfo.is_sys_admin;


export default CsvExportSanwa;
